// Version : 0.0.1
// LastEdit : KARTHEESWARAN
// MODFIED DATE:12-11-2025
//Last ADD : REMOVE COMMENTED LINES

// Version : 0.0.2
// LastEdit : AGALYA
// MODFIED DATE: 28-02-2026
// Last ADD : INITIAL STATE CHANGED AND UNWANTED ESLINT DISABLED

import AttendanceReportActionTypes from './attendance-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getAttendanceReportListResponse: null,
	getAttendanceReportListArr: [],
};
const attendanceReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************ GET ATTENDANCE REPORT LIST START **********************/
		case AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_SUCCESS:
			return {
				...state,
				getAttendanceReportListResponse: action.payload,
				getAttendanceReportListArr: docodeHexResponse(
					action.payload,
					'GetAttendanceReportKey',
				),
			};
		case AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_FAILURE:
			return { ...state, getAttendanceReportListResponse: action.payload };

		case AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getAttendanceReportListResponse: null };
		/************ GET ATTENDANCE REPORT LIST END **********************/
		default:
			return state;
	}
};

export default attendanceReportReducer;
